import { action } from 'typesafe-actions';

import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { HotelFilter } from 'models/hotelFilter';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';
import { HotelsResultResponse, HotelsSearchResponse } from 'models/hotelsSearch';
import { TravelArrangerUsersAllowed } from 'services/userService';

export const HOTELS_SEARCH_REQUEST = 'HOTELS_SEARCH_REQUEST';
export const HOTELS_SEARCH_SUCCESSFUL = 'HOTELS_SEARCH_SUCCESSFUL';
export const HOTELS_SEARCH_FAILURE = 'HOTELS_SEARCH_FAILURE';
export const HOTELS_SEARCH_PARAMETERS = 'HOTELS_SEARCH_PARAMETERS';
export const HOTELS_RESULT_REQUEST = 'HOTELS_RESULT_REQUEST';
export const HOTELS_RESULT_SUCCESSFUL = 'HOTELS_RESULT_SUCCESSFUL';
export const HOTELS_RESULT_FAILURE = 'HOTELS_RESULT_FAILURE';
export const HOTELS_FILTER_CLEAR = 'HOTELS_FILTER_CLEAR';
export const HOTELS_CLEAR = 'HOTELS_CLEAR';
export const HOTELS_SET_TRAVELER = 'HOTELS_SET_TRAVELER';

type HotelsSearchRequestArguments = {
  destinationPoint: TravelHotelContentLocationRequest;
  checkInDate: Date;
  checkOutDate: Date;
  traveler?: TravelArrangerUsersAllowed;
  branchCompany?: GetAllBillingCompanyResponse;
};

export const hotelsSearchRequest = ({
  destinationPoint,
  checkInDate,
  checkOutDate,
  traveler,
  branchCompany,
}: HotelsSearchRequestArguments) =>
  action(HOTELS_SEARCH_REQUEST, {
    destinationPoint,
    checkInDate,
    checkOutDate,
    traveler,
    branchCompany,
  });

export const hotelsSearchSuccessful = (search: HotelsSearchResponse) => action(HOTELS_SEARCH_SUCCESSFUL, search);

export const hotelsSearchError = (error: string) => action(HOTELS_SEARCH_FAILURE, error);

export const hotelsResultsRequest = (filters?: HotelFilter) =>
  action(HOTELS_RESULT_REQUEST, {
    filters,
  });

export const hotelsResultsSuccessful = (result: HotelsResultResponse[]) => action(HOTELS_RESULT_SUCCESSFUL, result);

export const hotelsResultsError = (error: string) => action(HOTELS_RESULT_FAILURE, error);

export const hotelsFilterClear = () => action(HOTELS_FILTER_CLEAR);

export const hotelsClear = () => action(HOTELS_CLEAR);

export const hotelsSetTraveler = (traveler?: TravelArrangerUsersAllowed) => action(HOTELS_SET_TRAVELER, traveler);

export const hotelsSearchParameters = ({
  destinationPoint,
  checkInDate,
  checkOutDate,
  traveler,
  branchCompany,
}: HotelsSearchRequestArguments) =>
  action(HOTELS_SEARCH_PARAMETERS, {
    destinationPoint,
    checkInDate,
    checkOutDate,
    traveler,
    branchCompany,
  });
